import React from "react";
import zhifubaoLogo from "../../../../assets/images/支付宝logo.png";
import { Form, Input, Button, Row, Col, message } from "antd";
import { fetchEditCapitalAccount } from "../../../../api/capitalAccount";
const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 }
  }
};
class Zhifubao extends React.Component {
  confirmzhifubao = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        fetchEditCapitalAccount({ ...values, type: "ALIPAY" }).then(res => {
          if (res.success) {
            message.success("编辑成功");
            this.props.cancelZhifubao();
            this.props.getAccountInfo();
          }
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isEdit1, aliPay } = this.props;
    return (
      <div className="salesRank">
        {isEdit1 ? (
          <React.Fragment>
            <div className="salesRankContent">
              <img src={zhifubaoLogo}></img>支付宝收银账户
            </div>
            <div className="lineBetweenWithoutMargin"></div>
            <div className="salesRankContent">
              <Form
                style={{ width: 500 }}
                onSubmit={this.confirmzhifubao}
                {...formItemLayout}
              >
                <Form.Item label="AppID">
                  {getFieldDecorator("aliPayAppId", {
                    initialValue: aliPay ? aliPay.appId : "",

                    rules: [{ required: true, message: "请输入AppID" }]
                  })(<Input placeholder="请输入AppID" />)}
                </Form.Item>
                <Form.Item label="公司名称">
                  {getFieldDecorator("companyName", {
                    initialValue: aliPay ? aliPay.companyName : "",
                    rules: [{ required: true, message: "请输入公司名称" }]
                  })(<Input placeholder="请输入公司名称" />)}
                </Form.Item>
                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                  <Button
                    style={{ marginRight: 20 }}
                    onClick={this.props.cancelZhifubao}
                  >
                    取消
                  </Button>
                  <Button type="primary" onClick={this.confirmzhifubao}>
                    确认
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {aliPay ? (
              <React.Fragment>
                {" "}
                <div className="salesRankContent">
                  <Row>
                    <Col span={12}>
                      <img src={zhifubaoLogo}></img>支付宝收银账户
                    </Col>
                    <Col span={12} align="right">
                      <a onClick={this.props.setZhifubao}>修改</a>
                    </Col>
                  </Row>
                </div>
                <div className="lineBetweenWithoutMargin"></div>
                <p style={{ paddingLeft: 24, paddingTop: 16 }}>
                  AppID:
                  <span style={{ paddingLeft: 20 }}>{aliPay.appId}</span>
                </p>
                <p style={{ paddingLeft: 24, paddingBottom: 24 }}>
                  公司名称:
                  <span style={{ paddingLeft: 20 }}>{aliPay.companyName}</span>
                </p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="salesRankContent">
                  <img src={zhifubaoLogo}></img>支付宝收银账户
                </div>
                <div className="lineBetweenWithoutMargin"></div>
                <div className="salesRankContent">
                  暂未填写，
                  <span
                    style={{ cursor: "pointer", color: "#3AA1FF" }}
                    onClick={this.props.setZhifubao}
                  >
                    去设置
                  </span>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default Form.create()(Zhifubao);
